module.exports = Em.Component.extend({
    classNames: ['additional-info-list-item'],

    classNameBindings: ['item.dropdownIsVisible:is-open'],

    item: null,

    annualReport: Em.inject.service(),

    actions: {
        didClickChoice: function(choice) {
            var self = this
            var item = this.get('item')

            var answer = {
                name: item.get('firstObject.name'),
                value: choice.get('value')
            }

            // Finds previous selected choice
            var prevChoice = item.get('choices').find(function(value) {
                return value.get('isSelected')
            })

            // Toggle isSelected class on choices
            this._resetChoiceState()
            choice.set('isSelected', true)

            if (choice.value) {
                this._openDropdown()
            } else {
                this._closeDropdown()
            }

            item.set('isValid', true)

            this.get('annualReport').putAnswer(item.year, [answer])
                .catch(function() {
                    // Reset UI state if not answered before
                    if (self.get('item.createdTime') === null) {
                        self._resetChoiceState()
                        self._closeDropdown()
                        item.set('isValid', false)
                    // Only change UI if another choice is selected
                    } else if (choice.value !== prevChoice.value) {
                        choice.set('isSelected', false)
                        prevChoice && prevChoice.set('isSelected', true)
                    }
                })
        }
    }
})
